import { lerPreferencias, type Som } from './preferencias';

/** Notas de cada som (Hz, curtas): sintetizadas, sem arquivo para baixar. */
const NOTAS: Record<Som, number[]> = {
  mensagem: [880],
  mencao: [988, 1319],
  dm: [784, 988],
  thread: [659, 880],
  enviada: [523],
  reacao: [1175],
  entrada: [523, 659, 784],
  urgente: [988, 740, 988, 740],
};

let contexto: AudioContext | null = null;

/**
 * Toca o som (se ligado nas preferências deste aparelho; `forcar` para o
 * "Ouvir" das configurações). O navegador só deixa depois de um clique na
 * página — antes disso, fica em silêncio.
 */
export function tocarSom(som: Som, forcar = false): void {
  if (!forcar && !lerPreferencias().sons[som]) return;
  try {
    contexto ??= new AudioContext();
    const agora = contexto.currentTime;
    NOTAS[som].forEach((frequencia, indice) => {
      const oscilador = contexto!.createOscillator();
      const volume = contexto!.createGain();
      oscilador.type = 'sine';
      oscilador.frequency.value = frequencia;
      const inicio = agora + indice * 0.11;
      volume.gain.setValueAtTime(0.0001, inicio);
      volume.gain.exponentialRampToValueAtTime(0.12, inicio + 0.01);
      volume.gain.exponentialRampToValueAtTime(0.0001, inicio + 0.16);
      oscilador.connect(volume).connect(contexto!.destination);
      oscilador.start(inicio);
      oscilador.stop(inicio + 0.18);
    });
  } catch {
    // Sem áudio (jsdom, navegador sem Web Audio): fica em silêncio.
  }
}
